module.exports = __webpack_public_path__ + "img/CS26Q-中_17.01adf027.jpg";